import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentV2Service, UtilService } from 'src/app/shared/services';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { SharedModule } from "../../shared/shared.module";
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { PaymentSipButtonModule } from "../payment-sip-button/payment-sip-button.module";

@Component({
  selector: 'app-maintenance-fee',
  standalone: true,
  templateUrl: './maintenance-fee.component.html',
  styleUrls: ['./maintenance-fee.component.scss'],
  imports: [
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatBottomSheetModule,
    MatDialogModule,
    PaymentSipButtonModule
  ]
})
export class MaintenanceFeeComponent implements OnInit {

  config;
  @ViewChild('feesBreakup') feesBreakup: TemplateRef<HTMLElement>;

  constructor(
    private util: UtilService,
    public sheet: MatBottomSheet,
    public dialog: MatDialog,
    private paymentV2: PaymentV2Service
  ) { }

  ngOnInit(): void {
    this.paymentV2.paymentConfig.subscribe(c => {
      this.config = { ...this.config, ...c };
    });
  }

  open(template) {
    if (this.util.isMobile()) {
      this.sheet.open(template, {
        panelClass: 'fee-bottom-sheet'
      })
    } else {
      this.dialog.open(template, {
        panelClass: 'fee-dialog'
      });
    }
  }

  closePopups() {
    !this.util.isMobile() ? this.dialog.closeAll() : this.sheet.dismiss();
  }

  onPaymentBtnClick() {
    this.paymentV2.pledgeBtn.next(this.config?.selectedTab?.name)
    this.closePopups()
  }

}
